import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectToken, selectCurrentUser } from '../slices/authSlice';
import { wsUrl } from '../api/wsUrl';
import useReconnectingSocket from './useReconnectingSocket';

export default function useGroupActivityDots(organizationId) {
  const token = useSelector(selectToken);
  const user = useSelector(selectCurrentUser);
  const [activeGroupIds, setActiveGroupIds] = useState(() => new Set());

  const orgId = user?.role === 'admin' ? organizationId : user?.organization_id;
  const url = token && orgId ? `${wsUrl()}/ws?token=${token}&scope=org&organizationId=${orgId}` : null;

  useReconnectingSocket(url, (msg) => {
    const groupId = msg.type === 'new-message' ? msg.data?.groupId : null;
    if (!groupId) return;
    setActiveGroupIds((prev) => {
      if (prev.has(groupId)) return prev;
      const next = new Set(prev);
      next.add(groupId);
      return next;
    });
  });

  const clear = useCallback((groupId) => {
    setActiveGroupIds((prev) => {
      if (!prev.has(groupId)) return prev;
      const next = new Set(prev);
      next.delete(groupId);
      return next;
    });
  }, []);

  return { activeGroupIds, clear };
}
